import { render } from "./RouterLinkButton.vue?vue&type=template&id=5735d773"
import script from "./RouterLinkButton.vue?vue&type=script&lang=js"
export * from "./RouterLinkButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buttons/RouterLinkButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5735d773"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5735d773', __exports__)) {
    api.reload('5735d773', __exports__)
  }
  
  module.hot.accept("./RouterLinkButton.vue?vue&type=template&id=5735d773", () => {
    api.rerender('5735d773', render)
  })

}


export default __exports__